// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.payments-bills-to-pay__container {
    margin: 24px;
    border-radius: 8px;
    background: var(--white-color);
}

.payments-bills-to-pay__container .baloa-normal-medium {
    padding: 24px;
    color: var(--primary-very-dark-color);
}

.payments-bills-to-pay__container .MuiTabs-root {
    padding-left: 0;
}

.payments-bills-to-pay__container .MuiTableRow-root.table-row {
    border-radius: 4px;
    border-bottom: 1px solid var(--new-gray-background-color);  
}

.payments-bills-to-pay__tornament {
    display: flex;
    align-items: center;
    justify-content: flex-start;
}

.payments-bills-to-pay__tornament img {
    border-radius: unset;
    margin-right: 8px;
    width: 44px;
    height: 44px;
}

.payments-bills-to-pay__tornament .baloa-names {
    color: var(--primary-very-dark-color);
}

.payments-bills-to-pay__tab .table-cell .baloa-names {
    color: var(--primary-very-dark-color);
}

.payments-bills-to-pay__tornament .baloa-username.Single_Payment {
    color: #0D96FD;
    background: #E3F2FD;
    border-radius: 4px;
    padding: 2px;
    width: fit-content;
    margin-top: 4px;
}

.payments-bills-to-pay__tornament .baloa-username.Payment_In_Installments {
    color: #2E7D32;
    background: #E8F5E9;
    border-radius: 4px;
    padding: 2px;
    width: fit-content;
    margin-top: 4px;
    display: flex;
    align-items: center;
}

.payments-bills-to-pay__tornament .baloa-username.parcial {
    color: var(--basic-gray-color);
    margin-top: 4px;
    margin-left: 4px;
}

.payments-bills-to-pay__tornament-cuotas {
    display: flex;
    align-items: center;
    justify-content: flex-start;
}

.payments-bills-to-pay__tornament-state.baloa-names.Success {
    color: #0F5132;
    background: #D1E7DD;
    border-radius: 4px;
    padding: 4px;
    width: fit-content;
}

.payments-bills-to-pay__tornament-state.baloa-names.Pending {
    color: #725912;
    background: #FFF3CD;
    border-radius: 4px;
    padding: 4px;
    width: fit-content;
}

.payments-bills-to-pay__tornament-state.baloa-names.Partial_Payment {
    color: #055160;
    background: #CFF4FC;
    border-radius: 4px;
    padding: 4px;
    width: fit-content;
}

.payments-bills-to-pay__tab {
    padding: 16px;
}

.payments-bills-to-pay__skeleton-row {
    display: flex;
    align-items: flex-start;
    margin-top: 20px;
    gap: 50px;
}

.payments-bills-to-pay__skeleton-row__image {
    display: flex;
    align-items: center;
    width: 50%;
    gap: 16px;
}
.payments-bills-to-pay__skeleton-row__image-data {
    width: calc(70% - 35px);
}`, "",{"version":3,"sources":["webpack://./src/app/payments/components/payments-bills-to-pay/PaymentsBillsToPayComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,kBAAkB;IAClB,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,qCAAqC;AACzC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,yDAAyD;AAC7D;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;IAC9B,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,UAAU;IACV,SAAS;AACb;AACA;IACI,uBAAuB;AAC3B","sourcesContent":[".payments-bills-to-pay__container {\n    margin: 24px;\n    border-radius: 8px;\n    background: var(--white-color);\n}\n\n.payments-bills-to-pay__container .baloa-normal-medium {\n    padding: 24px;\n    color: var(--primary-very-dark-color);\n}\n\n.payments-bills-to-pay__container .MuiTabs-root {\n    padding-left: 0;\n}\n\n.payments-bills-to-pay__container .MuiTableRow-root.table-row {\n    border-radius: 4px;\n    border-bottom: 1px solid var(--new-gray-background-color);  \n}\n\n.payments-bills-to-pay__tornament {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n}\n\n.payments-bills-to-pay__tornament img {\n    border-radius: unset;\n    margin-right: 8px;\n    width: 44px;\n    height: 44px;\n}\n\n.payments-bills-to-pay__tornament .baloa-names {\n    color: var(--primary-very-dark-color);\n}\n\n.payments-bills-to-pay__tab .table-cell .baloa-names {\n    color: var(--primary-very-dark-color);\n}\n\n.payments-bills-to-pay__tornament .baloa-username.Single_Payment {\n    color: #0D96FD;\n    background: #E3F2FD;\n    border-radius: 4px;\n    padding: 2px;\n    width: fit-content;\n    margin-top: 4px;\n}\n\n.payments-bills-to-pay__tornament .baloa-username.Payment_In_Installments {\n    color: #2E7D32;\n    background: #E8F5E9;\n    border-radius: 4px;\n    padding: 2px;\n    width: fit-content;\n    margin-top: 4px;\n    display: flex;\n    align-items: center;\n}\n\n.payments-bills-to-pay__tornament .baloa-username.parcial {\n    color: var(--basic-gray-color);\n    margin-top: 4px;\n    margin-left: 4px;\n}\n\n.payments-bills-to-pay__tornament-cuotas {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n}\n\n.payments-bills-to-pay__tornament-state.baloa-names.Success {\n    color: #0F5132;\n    background: #D1E7DD;\n    border-radius: 4px;\n    padding: 4px;\n    width: fit-content;\n}\n\n.payments-bills-to-pay__tornament-state.baloa-names.Pending {\n    color: #725912;\n    background: #FFF3CD;\n    border-radius: 4px;\n    padding: 4px;\n    width: fit-content;\n}\n\n.payments-bills-to-pay__tornament-state.baloa-names.Partial_Payment {\n    color: #055160;\n    background: #CFF4FC;\n    border-radius: 4px;\n    padding: 4px;\n    width: fit-content;\n}\n\n.payments-bills-to-pay__tab {\n    padding: 16px;\n}\n\n.payments-bills-to-pay__skeleton-row {\n    display: flex;\n    align-items: flex-start;\n    margin-top: 20px;\n    gap: 50px;\n}\n\n.payments-bills-to-pay__skeleton-row__image {\n    display: flex;\n    align-items: center;\n    width: 50%;\n    gap: 16px;\n}\n.payments-bills-to-pay__skeleton-row__image-data {\n    width: calc(70% - 35px);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
